import { configureStore } from '@reduxjs/toolkit';
import conversationsSlice from './conversations-slice';
import botSlice from './bot-slice';
const store = configureStore({
  reducer: {
    conversations: conversationsSlice,
    bots: botSlice
  } /* preloadedState, */,
  devTools:
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__(),
});

export default store;
